<template>
  <el-dialog
    top="8vh"
    :visible.sync="visible"
    width="983px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    style="border-radius: 4px"
  >
    <template slot="title"><div>上传素材</div></template>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="文件夹：" prop="folderId">
        <el-cascader
          v-model="ruleForm.folderId"
          :options="folder"
          :props="{
            value: 'id',
            label: 'name',
            children: 'children',
            emitPath: false,
          }"
          style="width: 500px"
        ></el-cascader>
      </el-form-item>

      <el-form-item label="玩法：" prop="playType">
        <el-radio-group
          v-model="ruleForm.playEditType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.playEditType === 'default'"
          v-model="ruleForm.playType"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in playList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.playRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in playTypeRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标签：" prop="tag">
        <el-radio-group
          v-model="ruleForm.tagType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-cascader
          v-if="ruleForm.tagType === 'default'"
          style="width: 500px; margin-top: 4px"
          placeholder="请选择规则"
          v-model="ruleForm.tag"
          :options="ruleOptions"
          clearable
          :props="{
            multiple: true,
            value: 'id',
            label: 'tagName',
            emitPath: false,
          }"
          filterable
        ></el-cascader>
        <el-select
          v-else
          v-model="ruleForm.tagRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in tagRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型：" prop="materialType">
        <el-radio-group
          v-model="ruleForm.materialEditType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.materialEditType === 'default'"
          v-model="ruleForm.materialType"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in materialTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.materialTypeRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in materialTypeRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="组别：" prop="groupType">
        <el-radio-group
          v-model="ruleForm.groupEditType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.groupEditType === 'default'"
          v-model="ruleForm.groupType"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.groupRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in groupTypeRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="尺寸：" prop="dimension">
        <el-radio-group
          v-model="ruleForm.dimensionType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.dimensionType === 'default'"
          v-model="ruleForm.dimension"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in dimensionList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.dimensionRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in dimensionRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设计：" prop="designer">
        <el-radio-group
          v-model="ruleForm.designerType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.designerType === 'default'"
          v-model="ruleForm.designer"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in designerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.designerRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in designerRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="后期：" prop="demander">
        <el-radio-group
          v-model="ruleForm.demanderType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.demanderType === 'default'"
          v-model="ruleForm.demander"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in demanderList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.demanderRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in demanderRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="语言：" prop="lang">
        <el-radio-group
          v-model="ruleForm.langEditType"
          size="mini"
          style="display: block"
        >
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select
          v-if="ruleForm.langEditType === 'default'"
          v-model="ruleForm.lang"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in languageList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="ruleForm.langRuleId"
          style="width: 500px"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in lanauageRuleList"
            :key="item.id"
            :label="item.ruleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="是否原创：" prop="creativeSource">
        <el-select v-model="ruleForm.creativeSource" style="width: 500px" placeholder="请选择" filterable>
          <el-option label="是" value="是"> </el-option>
          <el-option label="否" value="否"> </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="上传素材：">
        <div>已上传 {{ ruleForm.assetsList.length }} 个素材</div>
        <div class="assets-container">
          <div class="asset-item">
            <el-upload
              class="avatar-uploader"
              :action="actionUrl"
              :data="fileData"
              name="fileVal"
              multiple
              v-bind:on-progress="uploadVideoProcess"
              v-bind:on-success="handleVideoSuccess"
              v-bind:before-upload="beforeUploadVideo"
              v-bind:show-file-list="false"
              :on-error="handleVideoError"
            >
              <i
                v-if="!videoFlag"
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <el-progress
                v-if="videoFlag == true"
                type="circle"
                v-bind:percentage="videoUploadPercent"
                style="margin-top: 27px"
              ></el-progress>
            </el-upload>

            <!-- <canvas id="teset"></canvas> -->
          </div>
          <div
            v-for="(item, index) in ruleForm.assetsList"
            :key="item.msg"
            class="asset-item"
          >
            <div
              class="asset-item1"
              style="width: 243px; height: 194px"
              v-if="item.type == 'video/mp4'"
            >
              <div style="height: 130px; position: relative">
                <video
                  :src="item.path"
                  controlslist="nodownload"
                  width="225"
                  height="130"
                  controls
                  autoplay
                ></video>
                <i
                  class="el-icon-close"
                  style="
                    position: absolute;
                    top: -14px;
                    right: -7px;
                    background: #d6d6d6;
                    border-radius: 50%;
                    cursor: pointer;
                  "
                  @click="deleteMaterial(index)"
                ></i>
              </div>
              <div class="video-name">
                <span class="name">{{ item.name }}</span
                ><span>.{{ item.type.split("/")[1] }}</span>
              </div>
              <div class="video-detail">
                <span>{{ item.size }}M</span>
                <span>{{ item.resolution }}</span>
              </div>
            </div>
            <div v-else style="width: 243px; height: 194px" class="asset-item1">
              <div
                style="
                  position: relative;
                  height: 130px;
                  width: 225px;
                  margin: 0 auto;
                  background: rgb(232, 232, 232, 0.3);
                "
              >
                <img :src="item.path" class="imgpic" />
                <i
                  class="el-icon-close"
                  style="
                    position: absolute;
                    top: -14px;
                    right: -17px;
                    background: #d6d6d6;
                    border-radius: 50%;
                    cursor: pointer;
                  "
                  @click="deleteMaterial(index)"
                ></i>
              </div>
              <div class="video-name">
                <span class="name">{{ item.name }}</span
                ><span>.{{ item.type.split("/")[1] }}</span>
              </div>
              <div class="video-detail">
                <span>{{ item.size }}M</span>
                <span>{{ item.resolution }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item class="opeartion" style="height: 60px">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确定</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import {
  getMaterialFetch,
  saveFolderFetch,
  getTagFetch,
} from "../../api/material";
import {
  getTagRuleList,
  getMaterialTagRuleList,
  getTagPropertySelectList,
} from "@/api/property";
import { materialFieldsObj, materialRuleTypeOptions } from "@/config/fieldData";
// import MP4Box from "mp4box";
export default {
  data() {
    return {
      imgUrl: "",
      visible: false,
      tagName: "",
      materialFieldsObj,
      materialRuleTypeOptions,
      ruleForm: {
        folderId: null, // 文件夹
        assetsList: [], //素材列表
        playEditType: "auto",
        playType: null,
        playRuleId: "",
        tagType: "auto",
        tag: [], //标签
        tagRuleId: "",
        dimensionType: "auto",
        dimension: null,
        dimensionRuleId: "",
        groupEditType: "auto",
        groupType: null,
        groupRuleId: "",
        materialEditType: "auto",
        materialType: null,
        materialTypeRuleId: "",
        designerType: "auto",
        designer: null, //设计师
        designerRuleId: "",
        demanderType: "auto",
        demander: null,
        demanderRuleId: "",
        langEditType: "auto",
        lang: null,
        langRuleId: "",
        // creativeSource: null,
      },
      ruleOptions: [],
      tagRuleList: [],
      playTypeRuleList: [],
      materialTypeRuleList: [],
      groupTypeRuleList: [],
      dimensionRuleList: [],
      designerRuleList: [],
      demanderRuleList: [],
      lanauageRuleList: [],
      rules: {
        folderId: [
          {
            required: true,
            message: "请选择文件夹",
            trigger: "change",
          },
        ],
        tag: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.tagType === "default" &&
                this.ruleForm.tag.length === 0
              ) {
                callback(new Error("请至少选择一个标签"));
              } else if (
                this.ruleForm.tagType === "auto" &&
                !this.ruleForm.tagRuleId
              ) {
                callback(new Error("请选择标签规则"));
              } else {
                callback();
              }
            },
          },
        ],
        playType: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.playEditType === "default" &&
                !this.ruleForm.playType
              ) {
                callback(new Error("请选择玩法"));
              } else if (
                this.ruleForm.playEditType === "auto" &&
                !this.ruleForm.playRuleId
              ) {
                callback(new Error("请选择玩法规则"));
              } else {
                callback();
              }
            },
          },
        ],
        groupType: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.groupEditType === "default" &&
                !this.ruleForm.groupType
              ) {
                callback(new Error("请选择组别"));
              } else if (
                this.ruleForm.groupEditType === "auto" &&
                !this.ruleForm.groupRuleId
              ) {
                callback(new Error("请选择组别规则"));
              } else {
                callback();
              }
            },
          },
        ],
        materialType: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.materialEditType === "default" &&
                !this.ruleForm.materialType
              ) {
                callback(new Error("请选择类型"));
              } else if (
                this.ruleForm.materialEditType === "auto" &&
                !this.ruleForm.materialTypeRuleId
              ) {
                callback(new Error("请选择类型规则"));
              } else {
                callback();
              }
            },
          },
        ],
        dimension: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.dimensionType === "default" &&
                !this.ruleForm.dimension
              ) {
                callback(new Error("请选择尺寸"));
              } else if (
                this.ruleForm.dimensionType === "auto" &&
                !this.ruleForm.dimensionRuleId
              ) {
                callback(new Error("请选择尺寸规则"));
              } else {
                callback();
              }
            },
          },
        ],
        designer: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.designerType === "default" &&
                !this.ruleForm.designer
              ) {
                callback(new Error("请选择设计"));
              } else if (
                this.ruleForm.designerType === "auto" &&
                !this.ruleForm.designerRuleId
              ) {
                callback(new Error("请选择设计规则"));
              } else {
                callback();
              }
            },
          },
        ],
        demander: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.demanderType === "default" &&
                !this.ruleForm.demander
              ) {
                callback(new Error("请选择后期"));
              } else if (
                this.ruleForm.demanderType === "auto" &&
                !this.ruleForm.demanderRuleId
              ) {
                callback(new Error("请选择后期规则"));
              } else {
                callback();
              }
            },
          },
        ],
        lang: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                this.ruleForm.langEditType === "default" &&
                !this.ruleForm.lang
              ) {
                callback(new Error("请选择语言"));
              } else if (
                this.ruleForm.langEditType === "auto" &&
                !this.ruleForm.langRuleId
              ) {
                callback(new Error("请选择语言规则"));
              } else {
                callback();
              }
            },
          },
        ],
        // creativeSource: [{ required: true, message: "请选择创意来源", trigger: "blur" }],
      },

      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
        showVideoPath: "",
      },

      fileData: {},
      actionUrl: `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_CONTENT_PATH}/fileMgt/newFile`, //https://gateway.wedobest.com.cn:8465
      folder: [],
      playList: [],
      materialTypeList: [],
      dimensionList: [],
      groupList: [],
      designerList: [],
      demanderList: [],
      languageList: [],
      tagList: [],
      newTag: null,
      isCreateTag: false, //切换创建标签
      checkedTagList: [],
    };
  },

  methods: {
    handleClose() {
      this.visible = false;
      this.resetForm("ruleForm");
    },
    showModal(folderId) {
      this.ruleForm = {
        assetsList: [], //素材列表
        tagType: "auto",
        tag: [], //标签
        tagRuleId: "",
        playEditType: "auto",
        playType: null,
        playRuleId: "",
        dimensionType: "auto",
        dimension: null,
        dimensionRuleId: "",
        groupEditType: "auto",
        groupType: null,
        groupRuleId: "",
        materialEditType: "auto",
        materialType: null,
        materialTypeRuleId: "",
        designerType: "auto",
        designer: null, //设计师
        designerRuleId: "",
        demanderType: "auto",
        demander: null,
        demanderRuleId: "",
        langEditType: "auto",
        lang: null,
        langRuleId: "",
        // creativeSource: null,
      };
      this.ruleForm.folderId = folderId;
      this.visible = true;
      getMaterialFetch().then((res) => {
        this.folder = res.data;
      });
      this.materialFieldsObj.map((item) => {
        getTagPropertySelectList({ type: item.type }).then((res) => {
          this[item.optionsName] = res.data;
        });
      });
      this.materialRuleTypeOptions.map((item) => {
        getMaterialTagRuleList({ type: item.value }).then((res) => {
          this[item.ruleOptions] = res.data;
          if (res.data.length > 0) {
            this.ruleForm[item.ruleId] = res.data[0]?.id;
          }
        });
      });
      getTagRuleList().then((res) => {
        this.ruleOptions = res.data;
      });
      this.getTags();
    },
    getTags() {
      getTagFetch().then((res) => {
        this.tagList = res.data;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = [];
          this.ruleForm.assetsList.map((data) => arr.push(data.uuid));
          if (arr.length == 0) {
            this.$message.error("请上传素材");
            return;
          }
          const {
            // creativeSource,
            playEditType,
            playType,
            playRuleId,
            dimensionType,
            dimension,
            dimensionRuleId,
            groupEditType,
            groupType,
            groupRuleId,
            materialEditType,
            materialType,
            materialTypeRuleId,
            demander,
            demanderRuleId,
            demanderType,
            designer,
            designerRuleId,
            designerType,
            langEditType,
            lang,
            langRuleId,
            folderId,
            tag,
            tagRuleId,
            tagType,
          } = this.ruleForm;
          saveFolderFetch({
            // creativeSource,
            playEditType,
            playType,
            playRuleId,
            dimensionType,
            dimension,
            dimensionRuleId,
            groupEditType,
            groupType,
            groupRuleId,
            materialEditType,
            materialType,
            materialTypeRuleId,
            demander,
            demanderRuleId,
            demanderType,
            langEditType,
            lang,
            langRuleId,
            designer,
            designerRuleId,
            designerType,
            fileNames: arr,
            folderId,
            tag: tag.join(","),
            tagRuleId,
            tagType,
          }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("保存成功");
              this.visible = false;
              this.resetForm(formName);
              this.$emit("updateTable");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.assetsList = [];
      this.checkedTagList = [];
      this.visible = false;
    },
    //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 50;
      if (
        [
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          // "video/ogg",
          // "video/flv",
          // "video/avi",
          // "video/wmv",
          // "video/rmvb",
          // "video/mov",
        ].indexOf(file.type) == -1
      ) {
        this.$message("请上传正确的文件格式(mp4,jpeg,png,jpg)");
        return false;
      }
      if (!fileSize) {
        this.$message("视频大小不能超过50MB");
        return false;
      }
      this.isShowUploadVideo = false;
      const self = this;
      // 判断视频格式  正确的视频后缀会有mime信息
      // let result = new Promise((resolve, reject) => {
      //   const mp4boxFile = MP4Box.createFile();
      //   const reader = new FileReader();
      //   reader.readAsArrayBuffer(file);
      //   reader.onload = function (e) {
      //     const arrayBuffer = e.target.result;
      //     arrayBuffer.fileStart = 0;
      //     mp4boxFile.appendBuffer(arrayBuffer);
      //   };
      //   mp4boxFile.onReady = function (info) {
      //     resolve(info);
      //   };
      //   mp4boxFile.onError = function (info) {
      //     reject(info);
      //   };
      // });
      // console.log(result);
      //上传视频
      if (file.type.split("/")[0] == "video") {
        const isSize = new Promise(function (resolve, reject) {
          let _URL = window.URL || window.webkitURL;
          let videoElement = document.createElement("video");

          // // 当指定的音频/视频的元数据已加载时，会发生 loadedmetadata 事件。 元数据包括：时长、尺寸（仅视频）以及文本轨道。
          // videoElement.addEventListener("loadedmetadata", function () {
          //   let width = videoElement.videoWidth;
          //   let height = videoElement.videoHeight;
          //   let duration = videoElement.duration; // 视频时长
          //   console.log(width, height, duration, videoElement);
          //   width ? resolve() : reject("2222");
          //   self.fileData = {
          //     width,
          //     height,
          //     duration: parseFloat(duration).toFixed(2),
          //     fileSize: parseFloat(file.size / 1024 / 1024).toFixed(2),
          //   };
          // });
          videoElement.currentTime = 2;
          var image = new Image();
          videoElement.setAttribute("crossOrigin", "Anonymous");
          videoElement.addEventListener("loadeddata", function () {
            let width = videoElement.videoWidth;
            let height = videoElement.videoHeight;
            let duration = videoElement.duration; // 视频时长
            width ? resolve() : reject("2222");
            // 设置视频开始播放时间（因为有些手机第一帧显示黑屏，所以这里选取视频的第一秒作为封面）
            // 创建canvas元素 并设置canvas大小等于video节点的大小

            let scale = 0.8; // 压缩系数
            const imgSrc = self.compressCoverImg(videoElement, scale);
            self.imgUrl = imgSrc;
            image.src = imgSrc;
            // base64 转文件   uuid
            self.fileData = {
              width,
              height,
              duration: parseFloat(duration).toFixed(2),
              fileSize: parseFloat(file.size / 1024 / 1024).toFixed(2),
              fileCover: dataURLtoFile(imgSrc, `${new Date().getTime()}.jpg`),
            };
          });
          videoElement.src = _URL.createObjectURL(file);
        })
          .then(
            () => {
              return file;
            },
            () => {
              return Promise.reject("");
            }
          )
          .catch((e) => {
            console.log(e);
          });
        return isSize;
      } else {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            // 让页面中的img标签的src指向读取的路径
            let img = new Image();
            img.src = reader.result;
            if (img.complete) {
              img.width ? resolve() : reject();
              self.fileData = {
                width: img.width,
                height: img.height,
                duration: 0,
                fileSize: parseFloat(file.size / 1024 / 1024).toFixed(2),
              };
            } else {
              img.onload = () => {
                img.width ? resolve() : reject();
                self.fileData = {
                  width: img.width,
                  height: img.height,
                  duration: 0,
                  fileSize: parseFloat(file.size / 1024 / 1024).toFixed(2),
                };
              };
            }
          };
        }).then(
          () => {
            return file;
          },
          () => {
            return Promise.reject();
          }
        );
      }
    },
    // 压缩封面图片尺寸
    compressCoverImg(videoElement, scale) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = videoElement.videoWidth * scale;
      canvas.height = videoElement.videoHeight * scale;
      // canvas画图
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      // 把canvas转成base64编码格式
      const imgSrc = canvas.toDataURL("image/png");
      if (
        dataURLtoFile(imgSrc, `${new Date().getTime()}.jpg`).size >
          1 * 1024 * 1024 &&
        scale > 0
      ) {
        return this.compressCoverImg(videoElement, scale - 0.05);
      }
      return imgSrc;
    },
    //进度条
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;

      //前台上传地址
      //if (file.status == 'success' ) {
      //    this.videoForm.showVideoPath = file.url;
      //} else {
      //     this.$message("上传失败，请重新上传");
      //}

      //后台上传地址
      if (res.code == "0000") {
        this.videoForm.showVideoPath = res.path;
        this.ruleForm.assetsList.push(res);
        // this.$message.success("上传成功");
      } else if (res.code === "3000") {
        this.$message.error(res.msg);
      }
    },
    handleVideoError(err, file, fileList) {
      console.log(err, file, fileList);
      this.$message.error("上传失败，请重新上传");
      this.isShowUploadVideo = false;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
    },
    deleteMaterial(index) {
      this.ruleForm.assetsList.splice(index, 1);
    },
  },
};

function dataURLtoFile(dataurl, filename) {
  // 获取到base64编码
  const arr = dataurl.split(",");
  // 将base64编码转为字符串
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n); // 创建初始化为0的，包含length个元素的无符号整型数组
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: "image/jpeg",
  });
}
</script>
<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 243px;
  height: 203px;
  line-height: 203px;
  text-align: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 203px;
  line-height: 203px;
  text-align: center;
}
.avatar {
  width: 243px;
  height: 203px;
  display: block;
}
.imgpic {
  max-width: 100%;
  max-height: 130px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.assets-container {
  display: flex;
  flex-wrap: wrap;
  background: rgba(244, 244, 244, 1);
  padding-bottom: 12px;
  width: 819px;
  .asset-item {
    width: 245px;
    margin: 12px 12px 0 12px;
  }
  .asset-item1 {
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.11);
    background: rgba(255, 255, 255, 1);
    text-align: center;
    padding-top: 9px;
  }
}
.material-checkbox {
  display: block;
  padding: 4px 12px;
}
.tag-create {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 376px;
  height: 37px;
  background: rgba(0, 0, 0, 0.02);
  line-height: 37px;
  .tag-input {
    width: 269px;
  }
  .cancel {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.5);
  }
  .ok {
    cursor: pointer;
    color: rgba(24, 144, 255, 1);
  }
}
.tag-create1 {
  width: 376px;
  height: 37px;
  background: rgba(0, 0, 0, 0.02);
  line-height: 37px;
  text-align: center;
  color: rgba(24, 144, 255, 1);
  cursor: pointer;
}
.tag-popover {
  padding: 0;
}
.selected-tag {
  height: 30px;
  display: inline-block;
  width: 202px;
  line-height: 30px;
  border: 1px solid #dcdfe6;
  color: #7777;
  padding-left: 13px;
  border-radius: 2px;
}
.have-tag {
  color: #777777;
}
.tag-style {
  height: 22px;
  line-height: 22px;
  background: rgba(233, 233, 233, 0.6);
  border: rgba(233, 233, 233, 0.6);
  margin-right: 8px;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.85);
  .el-tag__close {
    color: rgba(0, 0, 0, 0.65);
  }
}
.video-name {
  height: 32px;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  font-family: Noto Sans SC;
  line-height: 32px;
  font-size: 14px;
  padding-left: 9px;
  display: flex;
  .name {
    display: inline-block;
    max-width: 192px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.video-detail {
  display: flex;
  justify-content: space-between;
  padding: 0 9px;
  color: rgba(0, 0, 0, 0.45);
  height: 32px;
  line-height: 24px;
}
.opeartion .el-form-item__content {
  margin-left: 782px !important;
  .el-button {
    padding: 0 15px;
  }
}
.tag-group {
  max-height: 450px;
  overflow-y: auto;
}
</style>

<style lang="less" scoped>
.demo-ruleForm {
  /deep/ .el-form-item {
    margin-bottom: 14px;
  }
}
</style>
